var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorkOrderItemSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "work-order-item-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.683,
    height: 19,
    viewBox: "0 0 16.683 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42267",
    "data-name": "Group 42267",
    transform: "translate(4.558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15221",
    "data-name": "Path 15221",
    d: "M37.582,23.492h6.4a.584.584,0,0,0,.582-.582V21.746A1.751,1.751,0,0,0,42.82,20H38.746A1.751,1.751,0,0,0,37,21.746V22.91A.584.584,0,0,0,37.582,23.492Z",
    transform: "translate(-37 -20)",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15222",
    "data-name": "Path 15222",
    d: "M36.9,25h-.6a.292.292,0,0,0-.3.319v1.276a2.479,2.479,0,0,1-2.383,2.552H27.064a2.479,2.479,0,0,1-2.383-2.552V25.319a.292.292,0,0,0-.3-.319h-.6A1.859,1.859,0,0,0,22,26.914V40.631a1.859,1.859,0,0,0,1.787,1.914H36.9a1.859,1.859,0,0,0,1.787-1.914V26.914A1.859,1.859,0,0,0,36.9,25Zm-1.549,7.656-5.72,6.125a.725.725,0,0,1-.536.255.788.788,0,0,1-.566-.255l-3.188-3.413a.347.347,0,0,1,0-.51l.626-.67a.3.3,0,0,1,.477,0l2.622,2.807,5.154-5.519a.3.3,0,0,1,.477,0l.626.67A.376.376,0,0,1,35.346,32.656Z",
    transform: "translate(-22 -23.545)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkOrderItemSvgrepoCom);
export default __webpack_public_path__ + "static/media/work-order-item-svgrepo-com.38885f70e21c5a5be42c77a8b774a559.svg";
export { ForwardRef as ReactComponent };